import React from 'react';
import StorageRounded from '@mui/icons-material/StorageRounded';
import MailRounded from '@mui/icons-material/MailRounded';
import { ReactComponent as OutlookLogo } from '../../../assets/connectors/outlook.svg';
import { ReactComponent as GmailLogo } from '../../../assets/connectors/gmail.svg';
import { ReactComponent as RedshiftLogo } from '../../../assets/connectors/redshift.svg';
import { ReactComponent as SnowflakeLogo } from '../../../assets/connectors/Snowflake.svg';
import { ReactComponent as BigQueryLogo } from '../../../assets/connectors/bigquery.svg';
import { ReactComponent as PostgresLogo } from '../../../assets/connectors/postgres.svg';
import { ReactComponent as SandboxAmsLogo } from '../../../assets/connectors/sandbox-ams.svg';

/** The mailbox's own mark: Outlook or Gmail. */
export function MailboxLogo({ provider, size = 20 }: { provider: string | null | undefined; size?: number }) {
  if (provider === 'outlook') return <OutlookLogo width={size} height={size} />;
  if (provider === 'gmail') return <GmailLogo width={size} height={size} />;
  return <MailRounded sx={{ fontSize: size }} />;
}

/** The warehouse's mark, from its name. */
export function WarehouseLogo({ name, size = 20 }: { name: string | null | undefined; size?: number }) {
  const n = (name || '').toLowerCase();
  if (n.includes('redshift')) return <RedshiftLogo width={size} height={size} />;
  if (n.includes('snowflake')) return <SnowflakeLogo width={size} height={size} />;
  if (n.includes('bigquery')) return <BigQueryLogo width={size} height={size} />;
  if (n.includes('postgres')) return <PostgresLogo width={size} height={size} />;
  return <StorageRounded sx={{ fontSize: size }} />;
}

/** The policy system's mark. Only the Sandbox AMS stand-in can be connected so far. */
export function PolicySystemLogo({ size = 20 }: { size?: number }) {
  return <SandboxAmsLogo width={size} height={size} />;
}
